import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Switch } from 'antd';
import { SwitchChangeEventHandler } from 'antd/lib/switch';
import React, { memo } from 'react';

interface IProps {
  active?: boolean;
  onChange?: SwitchChangeEventHandler;
  onClick?: SwitchChangeEventHandler;
  loading?: boolean;
}

export const SharedSwitch: React.FC<IProps> = memo(
  ({ active = false, onChange, onClick, loading = false }) => {
    return (
      <Switch
        loading={loading}
        checkedChildren={<CheckOutlined />}
        unCheckedChildren={<CloseOutlined />}
        checked={active}
        onChange={onChange}
        onClick={onClick}
      />
    );
  }
);
